<template>
	<div>
		<div class="accessStateQueryBox">
			<div class="queryBox">
				<span class="queryTitle">访员姓名</span>
				<span class="queryValue"><el-input size="medium" v-model="timeParams.name" placeholder="请输入内容"  clearable  :maxlength="50"></el-input></span>
			</div>
			<el-button class="queryBox" type="primary" size="medium" @click="loadData">搜索</el-button>
			<el-button class="queryBox" type="primary" size="medium" @click="exportExcel">导出</el-button>
		</div>
		<div class="topTable">
			<el-table :data="tableData" border :summary-method="getSummaries" show-summary style="width: 100%; margin-top: 20px">
				<el-table-column
					v-for="item in columnList"
					:key="item.enfieldName"
					align="center"
					:prop="item.enfieldName"
					:label="item.chfieldName"
					:fixed="item.fixed"
				></el-table-column>
			</el-table>
			<div class="block">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pagination.currentPage"
					:page-sizes="[1, 10, 50, 100, 200, 300, 400]"
					:page-size="pagination.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.total"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		surveyId: {
			type: String
		},
		source: {
			type: String
		}
	},
	data() {
		return {
			columnList: [],

			timeParams: {
				name: '',
				beginTime: '',
				endTime: ''
			},
			pagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			tableData: [],
		};
	},
	created() {
		this.loadData();
	},
	methods: {
		loadData() {
			let data = {
				userName: this.timeParams.name,
				beginTime: this.timeParams.beginTime,
				endExamTime: this.timeParams.endTime,
				currentPage: this.pagination.currentPage,
				pageSize: this.pagination.pageSize,
				source: this.source,
				surveyId: this.surveyId
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllSampleInterviewlogStatistics}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody.records);
						let column = [];
						let record = res.resultBody.records[0];

						for (let ele in record) {
							let temp = {
								chfieldName: ele,
								enfieldName: ele
							};
							column.push(temp);
						}

						column.forEach((item, index) => {
							if (item.chfieldName == 'userId') {
								column.splice(index, 1);
							}
						});
						let userName = {};
						column.forEach((item, index) => {
							if (item.chfieldName == '姓名') {
								userName = JSON.parse(JSON.stringify(item));
								column.splice(index, 1);
							}
						});
						column.unshift(userName);
						that.columnList = column;
						that.tableData = res.resultBody.records;
						that.pagination.total = res.resultBody.total;
					} else {
						that.tableData = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '总计';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);
					sums[index] += ' ';
				} else {
					sums[index] = 'N/A';
				}
			});
			return sums;
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pagination.pageSize = val;
			this.loadData();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.pagination.currentPage = val;
			this.loadData();
		}
		,
		exportExcel() {
			const loading = this.$loading({
				lock: true,
				text: '正在导出中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let that = this;
			let data = {
				userName: this.timeParams.name,
				beginTime: this.timeParams.beginTime,
				endExamTime: this.timeParams.endTime,
				source: this.source,
				surveyId: this.surveyId
			};
			let params = {
				that: this,
				url: `${this.$config.service.exportAllSampleInterviewlogStatistics}`,
				method: 'POST',
				responseType: 'arraybuffer',
				data: data,
				cb(resp) {
					let headers = resp.headers;
					let contentType = headers['content-type'];
					console.log('响应头信息', headers);
					if (!resp.data) {
						console.error('响应异常：', resp);
						loading.close();
						return false;
					} else {
						const blob = new Blob([resp.data], { type: contentType });
						const contentDisposition = resp.headers['content-disposition'];
						let fileName = 'unknown';
						if (contentDisposition) {
							fileName = window.decodeURI(resp.headers['content-disposition'].split('=')[1]);
						}
						let link = document.createElement('a');
						link.href = window.URL.createObjectURL(blob); // 创建下载的链接
						link.download = fileName; // 下载后文件名
						link.style.display = 'none';
						document.body.appendChild(link);
						link.click(); // 点击下载
						window.URL.revokeObjectURL(link.href); // 释放掉blob对象
						document.body.removeChild(link); // 下载完成移除元素
						loading.close();
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped lang="scss">
.el-row {
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}
.accessStateQueryBox {
	display: flex;
	.queryBox {
		display: flex;
		align-items: center;
		margin-left: 10px;
		.queryTitle {
			// line-height: 40px;
			font-size: 14px;
		}
		.queryValue {
			margin-left: 10px;
		}
	}
	.queryBox:first-child {
		margin-left: 0px;
	}
}

.topTable {
	margin-bottom: 20px;
	.block {
		text-align: right;
		margin-top: 20px;
	}
}
.centerBtn {
	display: flex;
	justify-content: right;
	.block {
		margin-top: 20px;
		display: flex;
		height: 40px;
		line-height: 40px;
		align-items: right;
	}
}
.botTable {
	/deep/.is-leaf {
		background-color: #007edc;
		color: #ffffff;
		font-size: 16px;
	}
	.block {
		text-align: right;
		margin-top: 20px;
	}
}
</style>
